<template>
  <div>
    <!--solo para desktop-->
    <div class="row second_header_desktop">
      <div class="col-md-9 col-sm-12 second_header_text">
        <p>Experiencias en gestión del <span class="span_second_title">cambio</span></p>
        <p>
          <span class="span_second_title">climático</span> del sector agropecuario en Colombia
        </p>
      </div>
      <div class="col-md-3 col-sm-12 container_img">
        <img src="header_index.png" alt="img" style="with:100%; height: 110px;" />
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>


<style>
@media (max-width: 768px) {
  .second_header_desktop {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .second_header_mobile {
    display: none !important;
  }
}
.second_header_desktop {
  margin: 0 !important;
  margin-top: 25px !important;
  padding-bottom: 70px;
  margin-left: -8px !important;
}
.second_header_text > p,
.second_header_text > p {
  padding: 0;
  margin: 0;
  font-size: 2em;
  line-height: 1.1;
  font-weight: bolder;
}
.span_second_title {
  color: #3366cc;
}
.container_img {
  width: 100% !important;
  margin-top: -20px;
}
</style>
